module.exports = __webpack_public_path__ + "media/images/front/products/standard/product_8-f6d98389369fa06731263c584ee959ad.jpg";